import { useQuery } from "@tanstack/react-query";
import { apiClient, buildQueryParams } from "@finitless/shared/lib";

/**
 * Build where clause for driver groups search
 */
const buildDriverGroupWhereClause = (searchTerm = "") => {
  const baseWhere = {
    conditions: [
      { attribute: "enabled", value: true },
      { attribute: "type", value: { condition: "!=", value: 1 } },
    ],
    conector: "AND",
  };

  // Add search condition
  if (searchTerm && searchTerm.trim()) {
    const searchValue = `%${searchTerm.trim()}%`;
    baseWhere.conditions.push({
      conector: "OR",
      conditions: [
        {
          attribute: "name",
          value: {
            condition: "ilike",
            value: searchValue,
          },
        },
      ],
    });
  }

  return baseWhere;
};

/**
 * Hook to get driver groups
 * @param {string} searchTerm - Optional search term to filter groups by name
 * @returns {Object} Query result with driver groups
 */
export const useDriverGroups = (searchTerm = "") => {
  const whereClause = buildDriverGroupWhereClause(searchTerm);

  const params = {
    params: "name,drivers,administrators,type",
    where: JSON.stringify(whereClause),
  };

  const queryString = buildQueryParams(params);

  return useQuery({
    queryKey: ["driverGroups", searchTerm],
    queryFn: async () => {
      const response = await apiClient.get(
        `/drivergroups${queryString ? `?${queryString}` : ""}`,
      );
      return {
        driverGroups: response?.result || [],
        pagination: response?.pagination || {},
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retry: false,
  });
};

export default {
  useDriverGroups,
};
